import { render, staticRenderFns } from "./submission-history-table.vue?vue&type=template&id=108d98fc"
import script from "./submission-history-table.vue?vue&type=script&lang=js"
export * from "./submission-history-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports